export const opts = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
}